var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.75v3.5c0 .41.34.75.75.75s.75-.34.75-.75v-3.5h3.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3.5V.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.5h-3.5c-.41 0-.75.34-.75.75s.34.75.75.75h3.5Z",
    fill: "currentColor",
    className: "accent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.75C0 0.335786 0.335786 0 0.75 0H9C9.41421 0 9.75 0.335786 9.75 0.75C9.75 1.16421 9.41421 1.5 9 1.5H1.5V13.5H4C4.25076 13.5 4.48494 13.6253 4.62404 13.834L6 15.8979L7.37596 13.834C7.51506 13.6253 7.74924 13.5 8 13.5H16.5V8.68182C16.5 8.2676 16.8358 7.93182 17.25 7.93182C17.6642 7.93182 18 8.2676 18 8.68182V14.25C18 14.6642 17.6642 15 17.25 15H8.40139L6.62404 17.666C6.48494 17.8747 6.25076 18 6 18C5.74924 18 5.51506 17.8747 5.37596 17.666L3.59861 15H0.75C0.335786 15 0 14.6642 0 14.25V0.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewReview);
export default __webpack_public_path__ + "static/media/new-review.985b76c3f43069a4f2206a8a8758eb8a.svg";
export { ForwardRef as ReactComponent };